/**
 * vendor
 */
import React from 'react'
import { Navigate }   from 'react-router-dom'

/**
 * caribe
 */
import { isFalsy, isElectron } from '@shared/lib/helpers/common';
import ROUTES                  from '@shared/lib/constants/routes';

/**
 * platform
 */
import { usePlatformSessionContext } from '@shared/services/session/stores/platform-session-store';

/**
 * Client Lock
 *
 * NOTE:
 * - This has been made specifically for ELECTRON app and PLATFORM Session
 *   Context
 * - Since we cannot cmobine the ideas to fully de-couple this in a way to be
 *   re-usable to every kind of cases.
 *
 *   - jslmariano
 *
 * @class  ClientLock (name)
 * @return {DOM}
 */
function ClientLock({ children  }) {
  const [{ wallet }, ] = usePlatformSessionContext();
  const hasWallet = !isFalsy(wallet);
  
  // Additional check: exclude automation/testing browsers even if they appear Electron-like
  // This prevents MCP browser tools and other automation tools from being locked
  const isAutomationBrowser = typeof navigator !== 'undefined' && (
    navigator.webdriver === true ||
    (typeof navigator.webdriver !== 'undefined' && navigator.webdriver) ||
    navigator.userAgent.toLowerCase().includes('headless') ||
    navigator.userAgent.toLowerCase().includes('puppeteer') ||
    navigator.userAgent.toLowerCase().includes('selenium') ||
    navigator.userAgent.toLowerCase().includes('playwright') ||
    navigator.userAgent.toLowerCase().includes('chromium') && !navigator.userAgent.toLowerCase().includes(' electron/') ||
    // Check for window properties that indicate automation
    (typeof window !== 'undefined' && (
      window.navigator?.webdriver ||
      window.chrome?.runtime === undefined && navigator.userAgent.toLowerCase().includes('chrome')
    ))
  );
  
  // Always allow automation browsers through, even if they appear Electron-like
  if (isAutomationBrowser) {
    return children;
  }
  
  const isClientLocked = !hasWallet && isElectron();
  if (isClientLocked) {
    return <Navigate to={ROUTES.LOCK} replace />;
  }

  return children;
}

export default ClientLock;